var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.248 1.75204C19.248 1.24819 18.9433 0.791205 18.4746 0.595914C18.0059 0.400623 17.4708 0.509986 17.1115 0.865416L15.4085 2.57226C13.5337 4.44706 10.991 5.50163 8.33899 5.50163H7.99918H6.74932H2.99973C1.62097 5.50163 0.5 6.6226 0.5 8.00136V11.751C0.5 13.1297 1.62097 14.2507 2.99973 14.2507V19.2501C2.99973 19.9415 3.55826 20.5 4.24959 20.5H6.74932C7.44065 20.5 7.99918 19.9415 7.99918 19.2501V14.2507H8.33899C10.991 14.2507 13.5337 15.3053 15.4085 17.18L17.1115 18.883C17.4708 19.2423 18.0059 19.3478 18.4746 19.1525C18.9433 18.9572 19.248 18.5041 19.248 17.9964V12.2353C19.9744 11.8916 20.4978 10.9659 20.4978 9.87615C20.4978 8.78643 19.9744 7.86075 19.248 7.51704V1.75204ZM16.7482 4.74781V9.87615V15.0045C14.4516 12.9149 11.4558 11.751 8.33899 11.751H7.99918V8.00136H8.33899C11.4558 8.00136 14.4516 6.83742 16.7482 4.74781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferIcon);
export default __webpack_public_path__ + "static/media/referIcon.02b362d8e1856b232e4c75b9a3922906.svg";
export { ForwardRef as ReactComponent };